<script>
import { mapState } from 'vuex'

export default {
  name: 'SubmitButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  computed: mapState({
    isLoading: 'isLoading',
  })
}
</script>

<template>
  <div>
    <button 
      :disabled="disabled"
      :class="{
        'inv-btn submit-button': true,
        'submit-button--loading': isLoading
      }"
      type="submit">

      <slot
        v-if="!isLoading"
        class="submit-button__text"
      />

      <img
        :class="{
          'submit-button__spinner--visible': isLoading
        }"
        class="submit-button__spinner"
        src="../assets/loading-spinner.svg"
      />
    </button>
  </div>
</template>

<style scoped>
.submit-button {
  width:100%;
  min-height: 40px;
  margin-top: -45px;
  background-color: #4693F8;
  transition:
    background-color 0.5s ease,
    box-shadow 0.5s ease;
}

.submit-button--loading {
  background-color: rgba(70, 147, 248, 0);
  box-shadow: none;
  pointer-events: none;
  cursor: default;
}

.submit-button__spinner {
  display: none;
  visibility: hidden;
  opacity: 0;
}

.submit-button__spinner--visible {
  display: block;
  visibility: visible;
  opacity: 1;
}
</style>
